/**
 * Effekt Element timeline (D-20) — live shipped this as an inline IIFE inside
 * sections/section-effect-element.liquid, keyed to the section id; the house
 * architecture moves it here as the <effect-timeline> custom element wrapping
 * the timeline itself. Behaviour is live's, 1:1:
 *
 *  - each .timeline-item fades/slides in via IntersectionObserver and out
 *    again when it leaves; the first item uses a shallower rootMargin
 *    (-20% vs -30%) and threshold (0.1 vs 0.2) so the timeline starts
 *    earlier, exactly live's two-observer split;
 *  - the rail (::before) grows to the bottom edge of the last visible item
 *    through the --timeline-line-height custom property;
 *  - in the theme editor everything is shown immediately.
 */
if (!customElements.get('effect-timeline')) {
  customElements.define(
    'effect-timeline',
    class EffectTimeline extends HTMLElement {
      connectedCallback() {
        const items = this.querySelectorAll('.timeline-item');
        if (items.length === 0) return;

        // In the Shopify editor, show all items immediately
        if (window.Shopify && window.Shopify.designMode) {
          items.forEach((item) => item.classList.add('is-visible'));
          this.style.setProperty('--timeline-line-height', '100%');
          return;
        }

        const updateLineHeight = () => {
          const visibleItems = this.querySelectorAll('.timeline-item.is-visible');
          if (visibleItems.length === 0) {
            this.style.setProperty('--timeline-line-height', '0px');
            return;
          }
          const lastVisible = visibleItems[visibleItems.length - 1];
          const lineHeight = lastVisible.offsetTop + lastVisible.offsetHeight;
          this.style.setProperty('--timeline-line-height', lineHeight + 'px');
        };

        const onIntersect = (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            } else {
              entry.target.classList.remove('is-visible');
            }
          });
          updateLineHeight();
        };

        this._firstObserver = new IntersectionObserver(onIntersect, {
          threshold: 0.1,
          rootMargin: '0px 0px -20% 0px',
        });

        this._observer = new IntersectionObserver(onIntersect, {
          threshold: 0.2,
          rootMargin: '0px 0px -30% 0px',
        });

        items.forEach((item, index) => {
          if (index === 0) {
            this._firstObserver.observe(item);
          } else {
            this._observer.observe(item);
          }
        });

        updateLineHeight();
      }

      disconnectedCallback() {
        if (this._firstObserver) this._firstObserver.disconnect();
        if (this._observer) this._observer.disconnect();
      }
    }
  );
}
